<template>
  <div class="max-w-xl m-auto">
    <terminals-search
      @searchClick="handleSearchBySerialNumber"
      :loading="loading"
    />

    <terminal-list
      :items="items"
      :loading="loading"
      :pagination="pagination"
      @onPrevious="onPrevious"
      @onNext="onNext"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Terminals',
  components: {
    TerminalList: () => import('./TerminalsList.vue'),
    TerminalsSearch: () => import('./TerminalsSearch.vue')
  },

  computed: {
    ...mapGetters(['terminals', 'loadingListTerminals']),
    items () {
      return this.terminals?.content ?? []
    },
    pagination () {
      return this.terminals?.pagination ?? {}
    },
    loading () {
      return this.loadingListTerminals
    }
  },
  methods: {
    ...mapActions({ getTerminals: 'GET_TERMINALS' }),
    onPrevious () {
      this.$router.replace({
        query: { ...this.$route.query, page: this.pagination.current_page - 1 }
      })

      this.getTerminals(this.$route.query)
    },
    onNext () {
      this.$router.replace({
        query: { ...this.$route.query, page: this.pagination.current_page + 1 }
      })

      this.getTerminals(this.$route.query)
    },
    handleSearchBySerialNumber (serialNumber) {
      const query = { ...this.$route.query, page: 1, size: 10 }

      if (!serialNumber) {
        delete query.serialNumber
      } else {
        query.serialNumber = serialNumber
      }

      this.$router.replace({
        query: { ...query }
      })
      this.getTerminals(this.$route.query)
    }
  },
  mounted () {
    this.getTerminals()
  }
}
</script>
